export const COMPONENT_NAME = 'Article';
